import React, { useState, useEffect } from "react";
import { ALERT_MESSAGE } from "../config";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import errorService from "../services/errorService";
import "./MapsterAlert.css";

const MapsterAlert = ({ title, severity, timerInput }) => {
  const [timer, setTimer] = useState(timerInput || ALERT_MESSAGE.TIMER);
  const [alerts, setAlerts] = useState([]);

  useEffect(() => {
    const handleErrorUpdates = (alerts) => {
      setAlerts(alerts.slice(0, ALERT_MESSAGE.MAX_ALERTS));
    };
    const unsubscribe = errorService.subscriber(handleErrorUpdates);

    return () => {
      unsubscribe();
    };
  }, []);

  useEffect(() => {
    const timers = alerts.map((_, index) =>
      setTimeout(() => {
        setAlerts((prevAlerts) => prevAlerts.filter((_, i) => i !== index));
      }, timer)
    );

    return () => {
      timers.forEach(clearTimeout);
    };
  }, [alerts, timer]);

  return (
    <div className="alert-container">
      {alerts.map((error, index) => (
        <Alert
          className="alert"
          key={index}
          severity={severity}
          onClose={() => {
            setAlerts((prevAlerts) => prevAlerts.filter((_, i) => i !== index));
          }}
        >
          <AlertTitle>{title}</AlertTitle>
          {error.message} x{error.count}
          {error.detail && <div>{error.detail}</div>}
        </Alert>
      ))}
    </div>
  );
};

export default MapsterAlert;
